<template>
     <span>{{ chipRole(params.value) }}</span>
</template>

<script>
export default {
  name: 'CellRendererVerified',
  computed: {
    textColor () {
      if (this.params.value === 'isStaff') return 'text-grey'
      else return 'text-primary' 
      // return this.params.value ? 'text-primary' : 'text-grey'
    },
    chipRole () {
      return (value) => {
        if (value === 'isStaff') return 'Staff'
        else return 'Customer'
      }
    }

  }
}
</script>
